import { useCallback, useEffect, useState } from "react";
import doctorService from "../doctorService";
import { ResponseDoctors } from "../interface/doctor.interface";
import IFilterDcotor from "../interface/filterDoctor.interafce";

const useGetDoctors = (filters: IFilterDcotor, enabled = true) => {
  const [data, setData] = useState<ResponseDoctors>();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>("");

  const callApi = useCallback(() => {
    return doctorService.getList(filters);
  }, [filters]);

  const transformResponse = useCallback((response: ResponseDoctors) => {
    if (response) {
      setData(response);
    }
  }, []);

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const response = await callApi();
      transformResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    (async () => {
      try {
        setLoading(true);
        const response = await callApi();
        transformResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [enabled]);

  return { data, error, isLoading, refetch };
};

export default useGetDoctors;
